import React from "react";
import { Nav as MNav } from "@magnetic/nav";
import NavDrawerItem from "./nav-drawer-item";

function NavDrawerItemGroup({ group, i18nNamespace, i18n, basePath, navItemClick }) {
  const { label, items = [] } = group;

  return (
    <MNav.Drawer.ItemGroup label={i18n.t(label, { ns: i18nNamespace }) || label}>
      {items &&
        items.map((item) => {
          return <NavDrawerItem key={item.id} item={item} i18nNamespace={i18nNamespace} i18n={i18n} basePath={basePath} navItemClick={navItemClick} />;
        })}
    </MNav.Drawer.ItemGroup>
  );
}

export default NavDrawerItemGroup;
